var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path10, _circle, _circle2, _path11, _circle3, _path12, _path13, _path14, _path15, _path16, _path17, _rect2, _path18, _rect3, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _rect4, _rect5, _path28, _path29, _path30, _rect6, _rect7, _rect8, _path31, _rect9, _path32, _circle4, _circle5, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreatorList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 199,
    viewBox: "0 0 215 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9423 116.817C23.5774 122.582 27.9972 127.756 32.8728 132.56C35.411 135.061 38.5538 138.434 42.0903 140.039C52.9074 145.79 77.9097 151.783 77.9097 151.783C77.9097 151.783 105.009 160.107 119.894 158.798C135.377 157.436 149.084 152.437 162.035 143.374C170.676 137.327 180.041 129.478 186.64 121.476C190.337 116.991 202.231 102.926 202.079 97.333C201.759 85.52 191.732 79.4107 183.05 71.5925C181.176 69.9054 180.943 65.8708 178.775 62.6745C175.843 58.3506 171.499 55.0303 169.195 53.3358C163.16 48.8962 155.561 41.636 148.416 38.7146C137.996 34.4541 109.873 37.4032 101.782 39.5694C89.1957 42.9391 77.3818 45.0049 68.6671 47.3978C64.3284 48.5891 60.752 50.4471 56.8344 52.6784C50.4245 56.3292 43.7856 62.5702 37.8363 66.943C33.511 70.1222 24.725 79.0009 21.5295 82.9139C13.5995 92.6244 14.1205 107.583 19.9423 116.817Z",
    fill: "#FFD5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.238 163.985L83.7143 162.581C84.2541 162.464 84.5968 161.932 84.4798 161.392L84.0003 159.18C84.2235 157.128 86.2495 156.021 85.1434 150.917C84.0374 145.813 79.7948 144.729 76.605 145.42C73.4152 146.111 69.3642 148.993 70.4703 154.097C71.5763 159.201 74.5167 159.231 75.5694 161.007L76.0489 163.219C76.1659 163.759 76.6983 164.102 77.238 163.985Z",
    fill: "#FFA90D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8396 136.417L75.9509 141.545L74.9253 141.768L73.814 136.64L74.8396 136.417Z",
    fill: "#FFA90D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9262 164.844L76.667 154.313C76.4936 153.753 76.8373 153.165 77.4105 153.04L78.444 152.816C78.9838 152.7 79.5162 153.042 79.6332 153.582L81.9774 164.399",
    stroke: "#2C2727",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0809 156.876L61.2458 157.924",
    stroke: "#FFA90D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8588 146.921L62.7815 144.1",
    stroke: "#FFA90D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2565 151.637L95.0916 150.589",
    stroke: "#FFA90D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1611 142.738L88.7046 138.482",
    stroke: "#FFA90D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.738,
    y: 164.998,
    width: 8.39547,
    height: 5.24717,
    rx: 1,
    transform: "rotate(-12.2277 76.738 164.998)",
    fill: "#B1B1B1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3061 129.647C72.8703 125.229 70.4824 116.962 69.6226 112.073C67.8717 102.116 66.0704 97.6707 70.1213 86.7079C77.8661 65.7481 104.489 56.8968 125.117 60.3209C130.98 61.2941 135.003 70.2751 139.712 71.822C156.821 77.4427 147.15 91.5019 150.05 105.056C150.008 116.573 135.785 131.297 129.545 132.632C118.114 135.077 113.912 133.378 100.179 131.829C92.0346 130.91 86.0915 134.304 79.3061 129.647Z",
    fill: "#3DA7E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.872 119.843C84.4421 116.802 82.7985 111.112 82.2066 107.747C81.0014 100.893 79.7616 97.8337 82.5499 90.2878C87.8808 75.8608 106.205 69.7683 120.404 72.1252C124.44 72.7951 127.209 78.9768 130.45 80.0416C142.227 83.9104 135.57 93.5876 137.566 102.917C137.537 110.844 127.747 120.979 123.452 121.898C115.584 123.581 112.692 122.412 103.239 121.345C97.6331 120.712 93.5424 123.049 88.872 119.843Z",
    fill: "#4ABBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.94574,
    cy: 3.94574,
    r: 3.94574,
    transform: "matrix(-1 0 0 1 127.406 89.0854)",
    fill: "#2C2727"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.94574,
    cy: 3.94574,
    r: 3.94574,
    transform: "matrix(-1 0 0 1 100.574 89.0853)",
    fill: "#2C2727"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.513 96.9811H105.043H103.465C103.465 100.142 106.41 102.505 109.778 102.505C113.146 102.505 116.091 100.142 116.091 96.9811H114.513Z",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.96819,
    cy: 99.4961,
    r: 9.96819,
    fill: "#FF5C83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 99.4961L8.14679 102.143C8.56823 102.565 9.26244 102.526 9.63477 102.061L14.4365 96.0588",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.922 79.8977C162.292 81.139 162.252 82.5245 162.698 83.7352L162.643 83.7532L165.616 92.8491L165.69 92.8209L165.716 92.8994L175.052 89.8096L175.04 89.7764C176.17 89.3807 177.154 88.5653 177.738 87.4137C178.94 85.0449 177.993 82.1506 175.625 80.9491C174.396 80.3257 173.025 80.2804 171.823 80.712C171.461 79.487 170.615 78.4078 169.386 77.7844C167.018 76.5828 164.123 77.529 162.922 79.8977Z",
    fill: "#FF5C83"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0385 66.7413C53.1855 66.6611 53.3502 66.619 53.5177 66.619H70.8147C71.8505 66.619 72.203 68.0004 71.2939 68.4967L47.7609 81.3443C47.614 81.4246 47.4492 81.4666 47.2818 81.4666H29.9848C28.949 81.4666 28.5964 80.0852 29.5056 79.5889L53.0385 66.7413Z",
    fill: "#F2F2F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4619 69.9183H63.1852",
    stroke: "#2C2727",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0381 73.2177H55.7614",
    stroke: "#2C2727",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6145 77.342H48.3378",
    stroke: "#2C2727",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8879,
    y: 46.2202,
    width: 22.2714,
    height: 2.4746,
    transform: "rotate(54.8408 39.8879 46.2202)",
    fill: "#FEC42E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7126 64.4282L50.6895 65.8532L52.8886 66.8266L52.7126 64.4282Z",
    fill: "#2C2727"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.29947,
    height: 2.4746,
    transform: "matrix(-0.575851 -0.817555 -0.817555 0.575851 39.8879 46.2202)",
    fill: "#FE636B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.44 46.5751V46.1732L104.047 46.0868L91.0189 43.2194L87.5159 20.3481C87.427 19.7673 86.9274 19.3385 86.3399 19.3385H60.6036C59.8748 19.3385 59.3173 19.9879 59.4277 20.7083L62.9449 43.6721V46.0638C62.9449 46.5877 63.2875 47.0498 63.7886 47.2021L75.1781 50.6629L75.2491 50.6845H75.3234H103.25C103.907 50.6845 104.44 50.1519 104.44 49.4949V46.5751Z",
    fill: "#F2F2F0",
    stroke: "#FFC6C6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3181 49.1498H85.4909L96.181 47.598L99.457 46.5635L89.1118 43.1151H64.2832V45.3566L75.3181 49.1498Z",
    fill: "#F2F2F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.025 22.0697L64.1481 41.7256C64.228 42.228 64.6612 42.5978 65.1699 42.5978H88.2527C88.8861 42.5978 89.3708 42.0337 89.2754 41.4075L86.2824 21.7516C86.2055 21.2462 85.7709 20.8728 85.2597 20.8728H62.0467C61.4106 20.8728 60.9252 21.4414 61.025 22.0697Z",
    fill: "#009CDB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9854 106.52C33.1569 107.08 32.8241 108.137 33.1829 109.07L44.3919 138.222C44.8874 139.51 46.453 140.003 47.5972 139.23L61.9964 129.508C62.825 128.949 63.1577 127.891 62.7989 126.958L51.5899 97.807C51.0944 96.5183 49.5289 96.0256 48.3846 96.7982L33.9854 106.52Z",
    fill: "white",
    stroke: "#FFE8E8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9512 109.594C36.6905 108.878 36.9547 108.077 37.5899 107.657L38.7255 106.905C39.1896 106.598 39.7774 106.546 40.2882 106.767L40.5139 106.865C41.056 107.099 41.6821 107.026 42.1548 106.672L46.3225 103.552C46.6723 103.29 46.8441 102.853 46.7662 102.423C46.6839 101.969 46.8799 101.51 47.2646 101.255L48.1999 100.636C49.088 100.049 50.2918 100.445 50.6562 101.446L59.8533 126.702C60.1139 127.418 59.8498 128.219 59.2146 128.639L48.6046 135.66C47.7165 136.247 46.5126 135.85 46.1482 134.85L36.9512 109.594Z",
    fill: "#FE6F32"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7974 103.754C43.9751 104.118 43.8244 104.557 43.4607 104.734C43.097 104.912 42.6582 104.761 42.4805 104.398C42.3028 104.034 42.4535 103.595 42.8172 103.417C43.1809 103.24 43.6197 103.39 43.7974 103.754Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M157.307 38.1212C155.882 33.4834 153.422 30.6077 150.792 31.3531",
    stroke: "#FFA90D",
    strokeWidth: 3.2631,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M153.458 36.5048C154.342 35.7051 155.565 35.3961 156.722 35.6801L172.938 39.6591L168.279 50.1174C166.967 53.0634 165.054 55.7029 162.663 57.867L155.06 64.748C154.916 64.8782 154.691 64.8548 154.577 64.6977L143.678 49.6765C142.601 48.1931 142.815 46.1371 144.174 44.9073L153.458 36.5048Z",
    fill: "#FFA90D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M160.331 30.1891C161.235 28.4247 163.398 27.727 165.163 28.6307L168.578 30.3801C168.851 30.5199 169.105 30.6941 169.333 30.8983L173.003 34.1775C174.221 35.2652 174.551 37.0374 173.806 38.4903L170.305 45.3266C170.223 45.487 170.026 45.5504 169.866 45.4683L159.308 40.0608C157.544 39.1571 156.846 36.9942 157.75 35.2298L160.331 30.1891Z",
    fill: "#FFA90D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.382,
    y: 39.0352,
    width: 13.2091,
    height: 13.576,
    rx: 6.60454,
    transform: "rotate(47.8525 147.382 39.0352)",
    fill: "#FFA90D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134.06,
    y: 46.3101,
    width: 17.2452,
    height: 4.76995,
    rx: 2.38497,
    transform: "rotate(28.164 134.06 46.3101)",
    fill: "#FFA90D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.146 61.2457C173.63 61.7802 174.456 61.8213 174.99 61.3376C175.525 60.8539 175.566 60.0285 175.082 59.494L173.146 61.2457ZM150.266 61.6643L155.527 67.4776L157.463 65.7259L152.201 59.9125L150.266 61.6643ZM161.519 67.7761L169.95 60.1453L168.198 58.2099L159.767 65.8407L161.519 67.7761ZM172.254 60.2601L173.146 61.2457L175.082 59.494L174.19 58.5084L172.254 60.2601ZM169.95 60.1453C170.618 59.5407 171.65 59.5921 172.254 60.2601L174.19 58.5084C172.618 56.7714 169.935 56.6377 168.198 58.2099L169.95 60.1453ZM155.527 67.4776C157.099 69.2146 159.782 69.3483 161.519 67.7761L159.767 65.8407C159.099 66.4453 158.067 66.3939 157.463 65.7259L155.527 67.4776Z",
    fill: "#FFA90D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M164.62 24.2307L167.822 32.4667L161.944 29.4559L164.62 24.2307Z",
    fill: "#FFA90D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M169.845 26.9071L173.7 35.4777L167.169 32.1323L169.845 26.9071Z",
    fill: "#FFA90D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 157.707,
    y: 35.1335,
    width: 9.90681,
    height: 21.6482,
    rx: 3.58941,
    transform: "rotate(47.8525 157.707 35.1335)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154.871,
    y: 45.123,
    width: 14.6768,
    height: 15.0437,
    rx: 7.33838,
    transform: "rotate(47.8525 154.871 45.123)",
    fill: "#FFA90D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 141.644,
    y: 54.1812,
    width: 16.1444,
    height: 4.76995,
    rx: 2.38497,
    transform: "rotate(24.3288 141.644 54.1812)",
    fill: "#FFA90D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.005 47.3776C162.346 40.0047 158.834 39.0179 156.622 40.824",
    stroke: "#FFA90D",
    strokeWidth: 3.2631,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 159.66,
    y: 31.8964,
    width: 8.80605,
    height: 4.03611,
    rx: 2.01805,
    transform: "rotate(23.6734 159.66 31.8964)",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M161.34 32.6329L164.7 34.1062C164.293 35.0342 163.211 35.4566 162.283 35.0498C161.355 34.6429 160.933 33.5609 161.34 32.6329Z",
    fill: "#FFD5E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.626,
    cy: 32.9094,
    r: 0.733838,
    transform: "rotate(23.6734 165.626 32.9094)",
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.929,
    cy: 31.2885,
    r: 0.733838,
    transform: "rotate(23.6734 161.929 31.2885)",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M181.735 107.67C181.735 104.632 184.198 102.17 187.235 102.17H199.369C202.406 102.17 204.869 104.632 204.869 107.67V114.643C204.869 116.532 203.337 118.063 201.448 118.063C200.661 118.063 200.105 118.835 200.354 119.581L201.388 122.683C201.546 123.158 200.985 123.545 200.597 123.228L194.699 118.402C194.431 118.183 194.096 118.063 193.749 118.063H187.235C184.198 118.063 181.735 115.601 181.735 112.563V107.67Z",
    fill: "#D6EFFF",
    stroke: "#FFBABA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.291 114.709C191.291 111.395 188.604 108.709 185.291 108.709H173.157C169.844 108.709 167.157 111.395 167.157 114.709V121.682C167.157 123.847 168.912 125.602 171.077 125.602C171.523 125.602 171.838 126.039 171.697 126.462L170.664 129.564C170.347 130.514 171.47 131.288 172.245 130.654L178.143 125.828C178.322 125.682 178.546 125.602 178.777 125.602H185.291C188.604 125.602 191.291 122.916 191.291 119.602V114.709Z",
    fill: "#C84F98"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.508 55.3331L21.8955 58.7421L25.6454 60.0035L21.8955 61.2649L20.508 64.6738L19.1204 61.2649L15.3706 60.0035L19.1204 58.7421L20.508 55.3331Z",
    fill: "#FE8591"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M194.245 66.542L195.633 69.9509L199.382 71.2123L195.633 72.4738L194.245 75.8827L192.857 72.4738L189.108 71.2123L192.857 69.9509L194.245 66.542Z",
    fill: "#FE8591"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M117.652 42.2561L119.039 45.665L122.789 46.9265L119.039 48.1879L117.652 51.5968L116.264 48.1879L112.514 46.9265L116.264 45.665L117.652 42.2561Z",
    fill: "#FE8591"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M126.992 16.1022L129.136 21.5565L134.932 23.5747L129.136 25.593L126.992 31.0473L124.848 25.593L119.052 23.5747L124.848 21.5565L126.992 16.1022Z",
    fill: "#4ABBFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M183.97 138.465L186.115 143.92L191.91 145.938L186.115 147.956L183.97 153.41L181.826 147.956L176.031 145.938L181.826 143.92L183.97 138.465Z",
    fill: "#4ABBFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.706 123.52L19.8504 128.975L25.6455 130.993L19.8504 133.011L17.706 138.466L15.5615 133.011L9.76636 130.993L15.5615 128.975L17.706 123.52Z",
    fill: "#4ABBFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.25 156.213H119.987V164.619H118.25C117.146 164.619 116.25 163.724 116.25 162.619V156.213Z",
    fill: "#F6539D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M156.415 140.333H160.152V148.74L140.069 164.619H133.531L156.415 140.333Z",
    fill: "#F6539D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M137.267 140.333H160.152L139.602 156.213H116.25L137.267 140.333Z",
    fill: "#F6539D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138.668 149.674L159.217 148.74L139.602 164.619H118.118L138.668 149.674Z",
    fill: "#F6539D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.184 158.213C117.184 157.108 118.08 156.213 119.184 156.213H139.602V163.685H119.184C118.08 163.685 117.184 162.79 117.184 161.685V158.213Z",
    fill: "#F2F2F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M159.218 141.268L139.602 156.213V163.685L159.218 147.806V141.268Z",
    fill: "#F2F2F0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorList);
export default __webpack_public_path__ + "static/media/creator-list.7be646c030a9ff3c1829726f2b3154bd.svg";
export { ForwardRef as ReactComponent };